export const TREE_VIEW_SVG_PATTERN_DARK_ID = 'TREE_VIEW_SVG_PATTERN_DARK_ID';
export const TREE_VIEW_SVG_PATTERN_LIGHT_ID = 'TREE_VIEW_SVG_PATTERN_LIGHT_ID';
